import { gql } from '@apollo/client'

export const CREATE_USER = gql`
  mutation createUser($input: CreateUserInput!) {
    data: createUser(input: $input) {
      id
    }
  }
`
